import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useTheme } from '@emotion/react';
export const PlayArrowIcon = ({ color, ...props }) => {
    const theme = useTheme();
    return (_jsx("svg", { width: "34", height: "39", viewBox: "0 0 34 39", fill: "none", ...props, children: _jsx("path", { d: "M34 19.5L0.250002 38.9856L0.250004 0.0144276L34 19.5Z", fill: color ?? theme.colors.white }) }));
};
//# sourceMappingURL=play_arrow_icon.js.map